import React from "react";
import { useNavigate } from "react-router-dom";
import CadastroRevenda from "./CadastroRevenda";
import { cadastrarRevenda } from "../services/api";

const NovoRevenda = ({ token }) => {
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    // Erros sobem para o catch de CadastroRevenda (alert).
    await cadastrarRevenda(data, token);
    alert("Revenda cadastrada com sucesso!");
    navigate("/revendas");
  };

  return <CadastroRevenda onSubmit={handleSubmit} token={token} />;
};

export default NovoRevenda;
